var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"openNumbers"},_vm._l((_vm.numbers),function(n,index){return _c('div',{key:n,class:{ active: index >= _vm.startIndex, openNumber: true }},[_vm._v(" "+_vm._s(n)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }